export const sumBy = <T>(items: Array<T>, accessor: (x: T) => number): number =>
	(items || ([] as Array<T>)).reduce((a, c) => (accessor(c) ? a + accessor(c) : a), 0);
